import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Gift, Footprints, Clapperboard, Shirt, Headphones, Home, MapPin, ShoppingBag, Smartphone, MoreHorizontal } from 'lucide-react';
const transactions = [{
  id: 1,
  icon: Gift,
  title: 'Birthday gift',
  category: 'Revenue',
  amount: '+ $100.00',
  color: 'text-green-500',
  iconBg: 'bg-orange-100',
  iconColor: 'text-orange-600'
}, {
  id: 2,
  icon: Footprints,
  title: 'Shoes',
  category: 'Clothing',
  amount: '- $79.00',
  color: 'text-gray-700',
  iconBg: 'bg-purple-100',
  iconColor: 'text-purple-600'
}, {
  id: 3,
  icon: Clapperboard,
  title: 'Movie theater',
  category: 'Entertainment',
  amount: '- $15.00',
  color: 'text-gray-700',
  iconBg: 'bg-blue-100',
  iconColor: 'text-blue-600'
}, {
  id: 4,
  icon: Shirt,
  title: 'Sweater',
  category: 'Clothing',
  amount: '- $30.00',
  color: 'text-gray-700',
  iconBg: 'bg-lime-100',
  iconColor: 'text-lime-600'
}, {
  id: 5,
  icon: Headphones,
  title: 'Music',
  category: 'Entertainment',
  amount: '- $10.00',
  color: 'text-gray-700',
  iconBg: 'bg-pink-100',
  iconColor: 'text-pink-600'
}];
export function PhoneMockup() {
  const [currentTransactionIndex, setCurrentTransactionIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTransactionIndex(prevIndex => (prevIndex + 1) % transactions.length);
    }, 2500);
    return () => clearInterval(interval);
  }, []);
  const getVisibleTransactions = () => {
    const visible = [];
    for (let i = 0; i < 3; i++) {
      visible.push(transactions[(currentTransactionIndex + i) % transactions.length]);
    }
    return visible;
  };
  return <motion.div initial={{
    opacity: 0,
    scale: 0.9
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    duration: 0.8,
    delay: 0.4
  }} className="relative" data-id="element-25">
      <div className="relative mx-auto w-80 h-[42rem] bg-white/50 rounded-[2.5rem] p-3 shadow-2xl shadow-black/20 border-4 border-black backdrop-blur-sm" data-id="element-26">
        <div className="w-full h-full bg-[#F7F5F2] rounded-[2rem] overflow-hidden flex flex-col [transform:translate3d(0,0,0)]" data-id="element-27">
          <div className="absolute inset-0 w-full h-full overflow-hidden" data-id="element-28">
            <div className="absolute top-0 left-0 w-64 h-64 bg-kraya-yellow/40 rounded-full blur-3xl opacity-60" data-id="element-29" />
            <div className="absolute bottom-0 right-0 w-56 h-56 bg-kraya-yellow/30 rounded-full blur-3xl opacity-50" data-id="element-30" />
          </div>

          <div className="relative flex-grow p-4 flex flex-col" data-id="element-31">
            <motion.div initial={{
            opacity: 0,
            y: -10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 1,
            duration: 0.5
          }} className="flex justify-between items-center mb-6" data-id="element-32">
              <div className="w-8 h-8 bg-gray-200 rounded-full" data-id="element-33"></div>
              <MoreHorizontal className="w-6 h-6 text-gray-400" data-id="element-34" />
            </motion.div>

            <div className="space-y-3 mb-4" data-id="element-35">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 1.2,
              duration: 0.5
            }} className="bg-white/80 backdrop-blur-md rounded-2xl p-4 border border-gray-100/80 shadow-sm" data-id="element-36">
                <div className="flex items-center gap-3" data-id="element-37">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-orange-100 rounded-full" data-id="element-38">
                    <Gift className="w-5 h-5 text-orange-600" data-id="element-39" />
                  </div>
                  <div data-id="element-40">
                    <p className="font-semibold text-gray-800 text-sm" data-id="element-41">
                      Today's Reward
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-42">
                      15% off your next order
                    </p>
                  </div>
                </div>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 1.4,
              duration: 0.5
            }} className="bg-white/80 backdrop-blur-md rounded-2xl p-4 border border-gray-100/80 shadow-sm" data-id="element-43">
                <div className="flex items-center gap-3" data-id="element-44">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-purple-100 rounded-full" data-id="element-45">
                    <Smartphone className="w-5 h-5 text-purple-600" data-id="element-46" />
                  </div>
                  <div data-id="element-47">
                    <p className="font-semibold text-gray-800 text-sm" data-id="element-48">
                      Order Ahead
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-49">
                      Skip the line, pick up in 5 mins
                    </p>
                  </div>
                </div>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 1.6,
              duration: 0.5
            }} className="bg-white/80 backdrop-blur-md rounded-2xl p-4 border border-gray-100/80 shadow-sm" data-id="element-50">
                <div className="flex items-center gap-3" data-id="element-51">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-green-100 rounded-full" data-id="element-52">
                    <MapPin className="w-5 h-5 text-green-600" data-id="element-53" />
                  </div>
                  <div data-id="element-54">
                    <p className="font-semibold text-gray-800 text-sm" data-id="element-55">
                      Local Spots
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-56">
                      Discover new favorites nearby
                    </p>
                  </div>
                </div>
              </motion.div>
            </div>

            <div className="flex-grow" data-id="element-57" />

            <div className="space-y-2 mb-4" data-id="element-58">
              <AnimatePresence mode="wait" data-id="element-59">
                {getVisibleTransactions().map(item => <motion.div key={item.id} initial={{
                opacity: 0
              }} animate={{
                opacity: 1
              }} exit={{
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="bg-white/70 backdrop-blur-md rounded-xl p-2 border border-gray-100/60 shadow-sm" data-id="element-60">
                    <div className="flex items-center gap-2" data-id="element-61">
                      <div className={`w-8 h-8 flex-shrink-0 flex items-center justify-center ${item.iconBg} rounded-lg`} data-id="element-62">
                        <item.icon className={`w-4 h-4 ${item.iconColor}`} data-id="element-63" />
                      </div>
                      <div className="flex-grow" data-id="element-64">
                        <p className="font-medium text-gray-800 text-xs" data-id="element-65">
                          {item.title}
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-66">{item.category}</p>
                      </div>
                      <p className={`font-semibold text-xs ${item.color}`} data-id="element-67">
                        {item.amount}
                      </p>
                    </div>
                  </motion.div>)}
              </AnimatePresence>
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 1.8,
            duration: 0.5
          }} className="flex justify-around items-center bg-white/60 backdrop-blur-md rounded-2xl p-3 border border-gray-100/50" data-id="element-68">
              <Home className="w-6 h-6 text-gray-400 opacity-70" data-id="element-69" />
              <MapPin className="w-6 h-6 text-gray-400 opacity-70" data-id="element-70" />
              <ShoppingBag className="w-6 h-6 text-gray-400 opacity-70" data-id="element-71" />
            </motion.div>
          </div>
        </div>
      </div>
    </motion.div>;
}